import { type RootState } from "~/app/store";
import { selectWishlists } from "~/features/wishlist/redux/wishlistSelectors";

export const selectShareableWishlists = (state: RootState) => {
  return selectWishlists(state).filter((wishlist) => wishlist.entryIds.length > 0);
};
